import logo from './logo.svg';
import './App.css';
import {BrowserRouter as Router,
Routes,
Route,
Link} from 'react-router-dom';
import Home from './component/home';
import About from './component/about';
import PrivacyPolicy from './component/privacy-policy'
import PrivacyPolicyET from './component/privacy-policyet'
import CookiePolicy from './component/cookies-policy';
import MPSTermsConditions from './component/termsandconditions';
import MPSTermsConditionsCard from './component/termsandconditionscard';
import FBDataDeletionUrl from './component/fbdatadeletionurl';
import ETTermsConditionsCard from './component/termsandconditionset';

function App() {
  return (
    <Router>
      <div className="App"/>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/termsandconditions' element={<MPSTermsConditionsCard/>}/>
        <Route path='/termsandconditioncard' element={<MPSTermsConditionsCard/>}/>
        <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
         <Route path='/privacy-policyet' element={<PrivacyPolicyET/>}/>
        <Route path='/cookies-policy' element={<CookiePolicy/>}/>
        <Route path='/fbdatadeletionurl' element={<FBDataDeletionUrl/>}/>
        <Route path='/termsandconditionset' element={<ETTermsConditionsCard/>}/>
      </Routes> 
    </Router>
  );
}

export default App;
